module.exports = __webpack_public_path__ + "media/images/lb/087-0e6940141a707b3d76e5b99ab7526478.svg";